/**
 * formStyles — 입력 폼 공용 클래스 (DESIGN-AI §12, 기준: Relationships 회사 추가)
 *
 * Tailwind 클래스라 ds-scope 안에서 써야 테두리가 그려진다(preflight:false).
 * 모달 안에서 쓸 때는 본문 래퍼에 ds-scope 를 붙인다 — ModalShell 은 호출부 본문을 건드리지 않으려고
 * 오버레이에 ds-scope 를 붙이지 않는다. 예: <ModalShell …><div className="ds-scope p-5">…</div></ModalShell>
 */
export const inputCls =
  "h-9 w-full rounded-lg border border-gray-200 bg-white px-3 text-[13px] text-gray-700 placeholder:text-gray-400 focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600/20 disabled:bg-gray-50 disabled:text-gray-500";
export const labelCls = "text-[12px] font-medium text-gray-500";
/** 라벨 + 입력칸 세로 묶음 */
export const fieldCls = "flex flex-col gap-1";
/** 2열 배치(좁으면 1열) */
export const formGridCls = "grid grid-cols-1 gap-x-3 gap-y-2.5 sm:grid-cols-2";
/** 폼 안 소제목 — 왼쪽 색 막대 없음 */
export const formSectionTitleCls = "text-[13px] font-bold text-gray-800";
export const helpTextCls = "text-[12px] text-gray-400";
export const formErrorCls = "rounded-lg bg-red-50 p-3 text-[12px] text-red-700";
